import { i18n } from '@/i18n'

/** 与 SoftwareSelectService.INSTALLED_GROUP_ID 一致 */
export const SOFT_GROUP_INSTALLED_OTHER_ID = 9999

/** 与 SoftwareSelectService 中 HAS_OTHER_GROUP_BUSINESS 一致：软件禁用、正版软件 */
const BUSINESS_SCENES_WITH_INSTALLED_OTHER: number[] = [1, 3]

export interface SoftGroupCatalogItem {
  group_id: number
  group_name: string
  group_desc: string
}

const GROUP_IDS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
] as const

/**
 * 软件分类静态目录（原 softmgr/soft-group/get），文案来自 i18n `softGroupCatalog.{id}.name|desc`。
 */
export function getSoftGroupCatalogListSync (): SoftGroupCatalogItem[] {
  const t = i18n.global.t
  return GROUP_IDS.map((id) => ({
    group_id: id,
    group_name: String(t(`softGroupCatalog.${id}.name`)),
    group_desc: String(t(`softGroupCatalog.${id}.desc`)),
  }))
}

/**
 * 软件选择器分组：部分业务场景追加「其他」分组（已安装且不在库内等）。
 */
export function getSoftGroupCatalogForSelect (businessScene: number): SoftGroupCatalogItem[] {
  const base = getSoftGroupCatalogListSync()
  if (BUSINESS_SCENES_WITH_INSTALLED_OTHER.includes(businessScene)) {
    return [
      ...base,
      {
        group_id: SOFT_GROUP_INSTALLED_OTHER_ID,
        group_name: String(i18n.global.t('softGroupCatalog.installedOther')),
        group_desc: '',
      },
    ]
  }
  return base
}

export function getSoftGroupNameById (groupId: number | string | null | undefined): string {
  if (groupId == null || groupId === '') return ''
  const id = Number(groupId)
  if (!Number.isFinite(id) || id < 1 || id > 23) return ''
  return String(i18n.global.t(`softGroupCatalog.${id}.name`))
}
